export default "__VITE_ASSET__BXJKQ$bb__"